import * as IoC from 'inversify';
import { registerCommand, registerQuery } from '@/app/tracking/api';
import { CompleteExamTrackingCommandName, QueryExamResultsTrackingQueryName } from '../api'
import { examCommonTrackingModule } from '../common/di'
import { Scorm2004CompleteExamCommandHandler } from './scorm2004-complete-exam-command-handler'
import { Scorm2004QueryExamResultsQueryHandler } from './scorm2004-query-exam-results-query-handler';

const examScorm2004TrackingModule = new IoC.ContainerModule((bind) => {
  registerCommand(CompleteExamTrackingCommandName, Scorm2004CompleteExamCommandHandler, bind);
  registerQuery(QueryExamResultsTrackingQueryName, Scorm2004QueryExamResultsQueryHandler, bind);
})

export const examScorm2004TrackingModules = [
  examCommonTrackingModule,
  examScorm2004TrackingModule
]
